import { NgModule } from '@angular/core';
import { MaterialModule } from '@alfresco/adf-core';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  imports: [MaterialModule, NgxMatFileInputModule, MatChipsModule, MatStepperModule, DragDropModule, MatButtonToggleModule],
  exports: [MaterialModule, NgxMatFileInputModule, MatChipsModule, MatStepperModule, DragDropModule, MatButtonToggleModule],
})
export class DeustoMaterialModule {}
